import React from "react";
import { TicketGridEditor } from "./editor/TicketGridEditor";

export const CreateTicketGridTemplate = () => {
  return <TicketGridEditor mode={"create"} onClose={() => null} />;
};
